import { render, staticRenderFns } from "./ShopinError.vue?vue&type=template&id=8ecbb68c&scoped=true&"
import script from "./ShopinError.vue?vue&type=script&lang=js&"
export * from "./ShopinError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ecbb68c",
  null
  
)

export default component.exports